// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconArrowLeft = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M51.9308 28.0008C50.9386 28.0234 29.1952 28.601 19.778 28.8514C25.2196 23.7818 32.7072 16.8061 33.2917 16.2615C34.2172 15.3992 34.2371 14.2786 33.3425 13.3841C32.448 12.4895 31.5104 11.5518 30.6159 10.6573C29.7214 9.76286 28.6007 9.78264 27.7384 10.7083C26.876 11.6338 9.97188 29.7786 9.17238 30.6366C8.37288 31.4947 8.37288 32.5052 9.17238 33.3633C9.97188 34.2215 26.876 52.3663 27.7384 53.2918C28.6007 54.2173 29.7213 54.2371 30.6159 53.3426C31.5104 52.448 32.448 51.5105 33.3425 50.616C34.237 49.7215 34.2172 48.6009 33.2916 47.7384C32.7072 47.1939 25.2196 40.2183 19.778 35.1487C29.1952 35.3991 50.9386 35.9767 51.9308 35.9993C53.1989 36.0281 53.9999 35.2452 53.9999 33.9766V30.0235C53.9999 28.7549 53.1989 27.972 51.9308 28.0008Z" />
    </svg>
  );
};
